import { MessageDataContentKeys } from "modules/Types";

export const labels: Record<MessageDataContentKeys, string> = {
  sentTo: "Sent to",
  openedBy: "Opened by",
  openingRate: "Open Rate",
  targets: "",
};

export const statusLabelColors = {
  SUBMITTED: "#10B981",
  SCHEDULED: "#F18500",
};

export const MAX_SUBJECT_LINE_LENGTH = 50;

export const MATCH_FILE_TAB_DEFAULT_VALUE = "none";

export const orderByFields: Record<string, string>  = {
  "platform": "platform",
  "source": "source",
  "email": "email",
  "location": "location",
  "added": "added",
}

export const orderByDirection: Record<string, string> = {
  "DESC": "DESC",
  "ASC": "ASC",
}
